import type {} from '@qunhe/egs-typings';
export * from './src/EGS.js';
import * as EGS from './src/EGS.js';
export default EGS;

window.EGS_MODULE_INITIALIZED = true;
